module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/ecommerce-header-style4/ecommerce-header-style4.component.scss
// module id = ./src/app/features/headers-styles/ecommerce-header-style4/ecommerce-header-style4.component.scss
// module chunks = main